import { render, staticRenderFns } from "./ContainerRequestsSubOrgs.vue?vue&type=template&id=2aab4194"
import script from "./ContainerRequestsSubOrgs.vue?vue&type=script&lang=js"
export * from "./ContainerRequestsSubOrgs.vue?vue&type=script&lang=js"
import style0 from "./ContainerRequestsSubOrgs.vue?vue&type=style&index=0&id=2aab4194&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports